module.exports = __webpack_public_path__ + "static/media/star3.a66ed6e7.svg";